export const backendApiAddress = (() => {
  if (window.location.hostname === "localhost") {
    // Another backend with REACT_APP_BACKEND, e.g. dev:
    // REACT_APP_BACKEND=https://dev.woolit.no yarn start
    return process.env.REACT_APP_BACKEND ?? "https://staging.woolit.no";
  }
  // Before the rule for design.woolit.no below, which would send dev to prod.
  if (window.location.hostname === "dev.design.woolit.no") {
    return "https://dev.woolit.no";
  }
  if (window.location.hostname.endsWith("snap0.woolit-designer.iterate.iterapp.no")) {
    return "https://staging.woolit.no";
  }
  if (window.location.hostname.endsWith(".dev.woolit.no")) {
    return "https://staging.woolit.no";
  }
  if (window.location.hostname.endsWith(".test.iterate.no")) {
    return "https://staging.woolit.no";
  }
  if (window.location.hostname.endsWith("testdesign.woolit.no")) {
    return "https://staging.woolit.no";
  }
  if (window.location.hostname.endsWith(".app.woolit.no")) {
    return "https://woolit.no";
  }
  if (window.location.hostname.endsWith("design.woolit.no")) {
    return "https://woolit.no";
  }
  return "https://woolit.no";
})();
